import { MsalGuardConfiguration } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  LogLevel,
  PublicClientApplication,
  IPublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

const API_SCOPE = `api://${environment.msalConfig.auth.clientId}/access_as_user`;
export const API_SCOPES = [API_SCOPE];
export const GRAPH_SCOPES = ['User.Read.All', 'GroupMember.ReadWrite.All'];

export function loggerCallback(_logLevel: LogLevel, message: string): void {
  if (!environment.production) {
    console.log(message);
  }
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: environment.msalConfig.auth.redirectUri,
      postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: environment.production ? LogLevel.Error : LogLevel.Info,
        piiLoggingEnabled: false,
      },
      // Proactively refresh tokens 5 minutes before they expire
      tokenRenewalOffsetSeconds: 300,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: API_SCOPES,
    },
    loginFailedRoute: '/login',
  };
}
